/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * usePresenceOfflineSignal.ts — us\1 \2resenc\1 \2fflin\1 \2ignal (services/operator-web-app).
 */

import { useEffect } from 'react';
import { operatorStore } from '@/store/operatorStore';
import { buildPresenceOffline } from '@/realtime/commands';
import { appConfig } from '@/config/env';

const OFFLINE_BEACON_URL = '/api/presence/offline';

/**
 * Sends presence_offline on beforeunload (WS if open + sendBeacon as backup).
 * Ensures operator is marked offline when tab closes.
 */
export function usePresenceOfflineSignal(): void {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleBeforeUnload = () => {
      const state = operatorStore.getState();
      if (state.connectionState === 'connected') {
        state.send(buildPresenceOffline('tab_close'));
      }
      const url = `${appConfig.apiBaseUrl.replace(/\/$/, '')}${OFFLINE_BEACON_URL}`;
      try {
        const body = JSON.stringify({ reason: 'tab_close' });
        navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
      } catch {
        // ignore
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);
}
